import { emptyObject } from '../../default-props/empty';

import get from 'lodash.get';

export const selectJobByJobId = (state, { jobId }) => get(state, `jobIdtoJobMap.${jobId}`);
export const selectLastAddedJobId = (state) => get(state, 'lastAddedJobId', '');
export const selectJobDataByJobId = (state, { jobId }) => get(state, `jobIdtoJobMap.${jobId}.data`, emptyObject);
